import { useContext, useEffect, useState } from "react";
import { ApplicationsContext } from "./Applications";
import css3 from "../Approvals/css/approval-table.module.css";
//../css/approval-table.module.css
import { FiMoreHorizontal as MoreIcon } from "react-icons/fi";
import {
  MdOutlineArrowBackIosNew as LBtn,
  MdOutlineArrowForwardIos as RBtn,
} from "react-icons/md";
import { convertTimetoString } from "../../../helperFunction";

const ApplicationTable = (props: any) => {
  const [activeData, setActiveData] = useState<any>([]);
  const [pageData, setPageData] = useState<any>([]);
  const [pageArr, setPageArr] = useState<any>([]);
  const [showMore, setShowMore] = useState<boolean>(false);
  const [showIndex, setShowIndex] = useState<any>(null);
  const [spanIndex, setSpanIndex] = useState<null | number>(null);
  const { setShowModal, setModalView, setModalData } =
    useContext(ApplicationsContext);

  const data: any = props?.data.Data ? props?.data?.Data : props?.data;
  const setCurrentPage = props?.setCurrentPage;
  const currentPage = props?.currentPage;
  const totalSize = props?.totalSize;

  const DATA_PER_PAGE = 10;

  const handlePrevous = () => {
    if (currentPage === 1) {
      if (pageArr.length > 1) {
        setCurrentPage(pageArr.at(-1));
        return false;
      }
      setCurrentPage(1);
      return false;
    }
    setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (pageArr.length > 1) {
      if (currentPage === pageArr.at(-1)) {
        setCurrentPage(1);
        return false;
      }
      setCurrentPage(currentPage + 1);
      return false;
    }
    setCurrentPage(1);
  };

  const handleMore = (index: number) => {
    if (index == showIndex) {
      setShowIndex(null);
      setShowMore(false);
      return;
    }
    setShowIndex(index);
    setShowMore(true);
  };

  const handleSpan = (index: number) => {
    if (index == spanIndex) {
      setSpanIndex(null);
      return;
    }
    setSpanIndex(index);
  };

  const handleViewDetails = (data: any) => {
    setModalView("view");
    setShowModal(true);
    setModalData(data);
  };

  useEffect(() => {
    if (totalSize && totalSize > 0) {
      setActiveData(data);

      // let lastPage = Math.ceil(data.length / 10);
      let lastPage = Math.ceil(totalSize / 10);
      let i = 1;
      let arr = [];
      for (i = 1; i < lastPage; i++) {
        arr.push(i);
      }

      setPageArr(arr);
      setPageData(data.slice(0, DATA_PER_PAGE));
    }
  }, [data]);

  useEffect(() => {
    if (activeData && activeData.length > 0) {
      let start = currentPage * DATA_PER_PAGE;
      let stop = start + DATA_PER_PAGE;
      setPageData(data.slice(start, stop));
    }
  }, [currentPage]);

  return (
    <div className={css3.container}>
      <>
        <div className={css3.gridStyle}>
          {/* <div>Applicant ID</div> */}
          <div>First Name</div>
          <div>Surname</div>
          <div>Email</div>
          <div>Phone</div>
          <div>Level</div>
          <div>Discipline</div>
          <div>Qualification</div>
          <div>Route Name</div>
          <div>Gender</div>
          <div>Date of Birth</div>
          <div>Marital Status</div>
          <div>Cert. Score</div>
          <div>Prof. Score</div>
          <div>Address</div>
          <div>App-Date</div>
          <div>Status</div>
        </div>

        <div>
          {pageData &&
            pageData.length > 0 &&
            pageData.map((eData: any, index: number): any => (
              <div key={index} className={css3.gridStyle}>
                {/* <div>{eData?.MembershipNo || "N/A"}</div> */}
                <div>{eData?.FirstName || "N/A"}</div>
                <div>{eData?.LastName || "N/A"}</div>
                <div>{eData?.Email || "N/A"}</div>
                <div>{eData?.PhoneNumber || "N/A"}</div>
                <div>{eData?.ExamLevel || "N/A"}</div>
                <div>{eData?.Discipline || "N/A"}</div>
                <div>{eData?.Qualification || "N/A"}</div>
                <div>{eData?.RouteName || "N/A"}</div>
                <div>{eData?.Gender || "N/A"}</div>
                <div>{eData?.DateBirth || "N/A"}</div>
                <div>{eData?.MaritalStatusId === 1
                      ? "Married"
                      : eData?.MaritalStatusId === 2
                      ? "Single"
                      : "N/A"}
                </div>
                <div>{eData?.CertificateScore || "N/A"}</div>
                <div>{eData?.ProfessionScore || "N/A"}</div>
                <div>{eData?.ContactAddress || "N/A"}</div>
                <div>{convertTimetoString(eData?.CreatedDate, 0) || "N/A"}</div>
                <div>{eData?.ApplicationStatus || "N/A"}</div>
                {/* <span
                  className={`${css3.moreSpan} ${
                    index == showIndex ? `${css3.activeMore}` : ""
                  } `}
                  onClick={() => handleMore(index)}
                >
                  <MoreIcon />
                  {index == showIndex && showMore ? (
                    <div>
                      <div onClick={() => handleViewDetails(eData)}>
                        View Details
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </span> */}
              </div>
            ))}
        </div>

        <div className={css3.pagination}>
          <div>
            <button
              className={`${css3.lBtn} ${css3.btn}`}
              onClick={handlePrevous}
            >
              <LBtn />
            </button>

            {pageArr &&
              pageArr.length > 0 &&
              pageArr.map((ePage: number, index: number) => {
                if (index <= 2 && currentPage <= 2)
                  return (
                    <span
                      style={
                        ePage == currentPage
                          ? {
                              backgroundColor: "var(--activeP-back)",
                              color: "var(--white-color)",
                            }
                          : {}
                      }
                      key={ePage}
                      onClick={() => setCurrentPage(ePage)}
                    >
                      {ePage}
                    </span>
                  );

                if (index + 1 == currentPage)
                  return (
                    <span
                      style={
                        ePage == currentPage
                          ? {
                              backgroundColor: "var(--activeP-back)",
                              color: "var(--white-color)",
                            }
                          : {}
                      }
                      key={ePage}
                      onClick={() => setCurrentPage(ePage)}
                    >
                      {ePage}
                    </span>
                  );

                if (
                  index >= pageArr.length - 3 &&
                  currentPage >= pageArr.length - 3
                )
                  return (
                    <span
                      style={
                        ePage == currentPage
                          ? {
                              backgroundColor: "var(--activeP-back)",
                              color: "var(--white-color)",
                            }
                          : {}
                      }
                      key={ePage}
                      onClick={() => setCurrentPage(ePage)}
                    >
                      {ePage}
                    </span>
                  );

                if (index + 1 == pageArr.length - 1)
                  return (
                    <>
                      <>...</>
                      <span
                        style={
                          ePage == currentPage
                            ? {
                                backgroundColor: "var(--activeP-back)",
                                color: "var(--white-color)",
                              }
                            : {}
                        }
                        key={ePage}
                        onClick={() => setCurrentPage(ePage)}
                      >
                        {ePage}
                      </span>
                    </>
                  );

                if (index == 0)
                  return (
                    <>
                      <span
                        style={
                          ePage == currentPage
                            ? {
                                backgroundColor: "var(--activeP-back)",
                                color: "var(--white-color)",
                              }
                            : {}
                        }
                        key={ePage}
                        onClick={() => setCurrentPage(ePage)}
                      >
                        {ePage}
                      </span>
                      <>...</>
                    </>
                  );
              })}

            <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext}>
              <RBtn />
            </button>
          </div>
        </div>
      </>
    </div>
  );
};

export default ApplicationTable;
